export default {
  interests: 'Interests',
};
